<app-dialog
  [title]="data.title"
  (close)="closePopup()"
>
  <div class="image" *ngIf="data">
    <img [src]="data.url" />
  </div>
</app-dialog>
